import React, {useState, useEffect, useCallback, useContext, useRef} from 'react';
import { IDSConfig } from '@state/dsconfig/types';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import InfiniteScroll from 'react-infinite-scroll-component';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import ItemTemplate from '../ItemTemplate';
import PreviewComponent from '../../../../../Studio/components/PreviewComponent';
import Button from '@components/Button';
import Spinner from '@components/Spinner';
import Loading from '@components/Loading';
import actions from '@state/actions';
import { openNewTemplateAction, reloadListAction } from '@state/openReducers/actions';
import { setParams } from '@utils/userUtils';
import selectors from '@state/selectors';
import { TemplatesContext } from '@utils/DOIgnition/TemplatesContext';
import { IndexesActions, IProps } from './types';
import * as S from './styles';
import { ListEmpty } from '@assets/icons/listEmpty';
import _ from "lodash";
import { Compression } from 'ag-psd/dist/helpers';
import { getBrandIdByOEMName } from 'utils/editor';
import MouseSelection from '@components/MouseSelection';
import { boxesIntersect, SelectionBox } from 'react-drag-to-select';
import RightClickMenu from '@components/RightClickMenu';
import { ColName } from '../ItemTemplate/styles';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { IUserType } from '@state/auth/types';

const List:React.FC<IProps> = ({filters, activeFilter, orderBy, onActionsTemplate, deteleItem, savedItems, gridView,deleteTemplates, handleWarningScreen}) => {
  const dsConfig: IDSConfig = useSelector(selectors.dsConfig.getDSConfig);
  const{ searching, value, setSearchQuery, 
         location, templatesFormat, setItemsfl, 
         fetchCounter, setFilterQuery, filtering, forceSearch,
         getQuerySearchFilters, hasDesigns, sortByText, showCounter,
         setSearching, setShowList} = useContext(TemplatesContext);

  const authContext = React.useContext(AuthContext);
  const isAdmin = authContext.userData && authContext.userData.profile && authContext.userData.profile.role === IUserType.ADMIN;
  const userData = authContext && authContext.userData?authContext.userData.profile:undefined;
  

  const [initial, setInitial]=useState(true);
  const [reload, setReload]=useState(false);
  const [title, setTitle]=useState("Loading templates...")
  const [filter, setFilter]=useState({} as any);
  const [start, setStart]=useState(0)
  const [hasMore, setHasmore]=useState(true)
  const [show, setShow]=useState(false);
  const [spinner, setSpinner]=useState(true);
  const [orderPublished, setOrderPublished]=useState('')
  const [selectedIndexes, setSelectedIndexes] = useState<number[]>([]);
  const [allowClean, setAllowClean] = useState<boolean>(true);
  const [openOptions, setOpenOptions] = useState(false);
  const [coordinates, setCoordinates] = useState({x: 0, y: 0});  
  const [customPageSize, setCustomPageSize]=useState(20);
  const dispatch = useDispatch();
  const history = useHistory();

  const refTop = useRef<HTMLDivElement>(null);
  const scrollDiv = useRef<HTMLDivElement>(null);
  const stateRef = useRef<boolean>();
  const selectedRefs = React.useRef<(HTMLDivElement | null)[]>([]);
  const templates = useSelector(selectors.templates.getTemplates);
  const newTemplate = useSelector(selectors.open.getOpenTemplate);
  const reloadList = useSelector(selectors.open.getReloadList);
  const counter = useSelector(selectors.templates.getTemplateCounter);
  
  const getCustomPageSize= () => {
    const defaultPageSize = 20;
    if(start<=customPageSize) {
      const {clientHeight,clientWidth} = document.documentElement;
      //
      let listTop=186;
      if(location==='studio' && !hasDesigns && filtering) listTop=390;
      if(searching) listTop=186;
      //
      const height = refTop.current?.getBoundingClientRect().height||clientHeight-listTop;
      let itemWidth=229;
      let itemHeight = 291;
      let listWidth = clientWidth-496;
      /*
      const elementsContainer = document.getElementById("template-list");
      if(elementsContainer && elementsContainer?.children[0]) {
        console.log('elementsContainer',elementsContainer.children[0].getBoundingClientRect());
        itemWidth=elementsContainer.children[0].getBoundingClientRect().width;
        itemHeight = elementsContainer.children[0].getBoundingClientRect().height;
        const {width} = elementsContainer.getBoundingClientRect();
        listWidth = width;
      } 
      */ 
        const rowSize = Math.floor(listWidth/itemWidth);
        const rows = Math.ceil(height/itemHeight);
        setCustomPageSize(Math.max((rowSize*rows),defaultPageSize));
    }
    else setCustomPageSize(defaultPageSize);
  }

  const fetchTemplates = (restart:boolean=false) => {
    if(templatesFormat && templatesFormat.length==0)setSpinner(true);
    
    let query=createQuery(restart);        
    return new Promise((resolve, reject) => {
      dispatch(actions.templates.fetchTemplates(query,(result, error) => {
        if (error) reject(error)
        else resolve(result)
      }))
    });
  }
 
  const createQuery=(restart:boolean)=>{
    let filtersQuery=``;
    let addOr=false;
    let startQuery=0;
    let addExtraClosingParenthesis=false;
    if(!restart){
      startQuery=start;
      setStart(start+customPageSize);
    }else{
      setItemsfl([]);
      setStart(customPageSize);
      setSpinner(true);
    }

    if(filter){
      Object.keys(filter).forEach((key) => {
          if (filter[key].length>0){
            let columQuery='';
            if(key==='templateStatus')columQuery=` c.${key} IN (`;
            else{ 
              if (key=="format"){
                columQuery=` EXISTS ( SELECT VALUE t FROM t in c.tags.formats WHERE t.name IN (`;
                //columQuery=` c.tags.${key}.name IN (`;
                addExtraClosingParenthesis=true;
              }
              else
                columQuery=` c.tags.${key} IN (`;
            }
            if(addOr)columQuery=' and'+columQuery;
            let item=filter[key];

            item.forEach((text:string, idx:number) => {
              if(key==='templateStatus')columQuery=columQuery+`'${text.toUpperCase()}'`;
              else if(key==='oem') columQuery=columQuery+`'${getBrandIdByOEMName(text, dsConfig)}'`;
              else columQuery=columQuery+`'${text}'`;
              if (idx < item.length-1)columQuery=columQuery+`,`;
            });

            columQuery=addExtraClosingParenthesis ? columQuery+`))` : columQuery+`)`;
            filtersQuery=filtersQuery+columQuery
            if(filtering)setFilterQuery(filtersQuery);
            addOr=true;
          } else if (key === 'oem' && userData.role === 'DealerUser' ) {
            filtersQuery += `c.tags.oem IN ('${dsConfig.brands.filter(b => b.id).map(b => b.id).join(`','`)}')`
            addOr = true;
          }

          if (key ==="format" && filter[key] && filter[key].name) {
            filtersQuery = filtersQuery + ` and udf.searchFormat(c.tags.formats, '${filter[key].name}', c.templateStatus) `;
          }
      });
    }

    let order="c.templateStatus DESC,c.createdDate DESC";
    if(location==="studio"){
      if(searching)order="c.name";
      if(filtering)order="c.updateDate DESC";
    }
    else if(searching)order="c.templateStatus DESC";

    if(orderBy!==""){
        if((orderBy==="PUBLISHED")||(orderBy==="UNPUBLISHED"))
        {
          if(((orderBy==="PUBLISHED")&&(orderPublished===''))||(restart)){
            if(addOr)filtersQuery=filtersQuery+` and c.templateStatus='${orderBy}'`;
            else filtersQuery=filtersQuery+`  c.templateStatus='${orderBy}'`;
          }
          else if((orderPublished==="UNPUBLISHED")||(orderBy==="UNPUBLISHED")){
            
            if(orderPublished==''){
              setStart(customPageSize);
              startQuery=0;
            }
            else{
              if(restart)startQuery=0;
              else startQuery=start;
            }

            if(addOr)filtersQuery=filtersQuery+` and c.templateStatus<>'PUBLISHED'`;
            else filtersQuery=filtersQuery+`  c.templateStatus<>'PUBLISHED'`;
            order="c.templateStatus DESC"
          }
        }else order=orderBy;
    }
    if(searching || filtering){
        const state=location==='studio'?`='PUBLISHED'`:`<>'INACTIVE'`;
        if(orderPublished==="UNPUBLISHED") filtersQuery=`(c.templateStatus${state} ${filtersQuery!=="" ? `and${filtersQuery}`:``} and c.formatName LIKE "%${value.toLowerCase()}%") or (udf.searchCustomTags(c.tags.customTags, "${value.toLowerCase()}", c.templateStatus) ${filtersQuery!=="" ? `and${filtersQuery}`:``})`;
        else if(orderBy==="UNPUBLISHED") filtersQuery=`(c.templateStatus${state} ${filtersQuery!=="" ? `and${filtersQuery}`:``} and c.formatName LIKE "%${value.toLowerCase()}%") or (udf.searchCustomTags(c.tags.customTags, "${value.toLowerCase()}", c.templateStatus, '', 'PUBLISHED') ${filtersQuery!=="" ? `and${filtersQuery}`:``})`;
        else if(orderBy==='PUBLISHED')filtersQuery=`(${filtersQuery} and c.formatName LIKE "%${value.toLowerCase()}%") or (${filtersQuery} and udf.searchCustomTags(c.tags.customTags, "${value.toLowerCase()}", c.templateStatus, 'PUBLISHED'))`;
        else filtersQuery=getQuerySearchFilters(filtersQuery);
    }
    else{
      if(filtersQuery!=='')filtersQuery=`c.templateStatus<>'INACTIVE' and `+filtersQuery;
      else filtersQuery=`c.templateStatus<>'INACTIVE' `;
    }

    filtersQuery = encodeURIComponent(filtersQuery);
    return `?filter=${filtersQuery}&userdata=${JSON.stringify(userData)}&all=${location=="studio"?"true":""}&orderby=${order}&start=${startQuery}&pagelength=${customPageSize}`;
  }

  const handleOpenNewTemplate = () => {
    dispatch(reloadListAction(false));
    dispatch(openNewTemplateAction(true));
    const url = setParams({ page: "new-template" });
    history.push(`?${url}`);
  }

  useEffect(() => {
    getCustomPageSize();

    if(location==='templates'){
      setTimeout(function() {
        const run = async () => {
          await fetchTemplates(false);
          setTitle("No templates added")
        }
        run();
      }, 200);
    }
  }, [])
/*
  useEffect(() => {
    console.log('useEffect w empty deps - Resize',)

    function handleResize() {
      getCustomPageSize();
      console.log('RESIZE handler items n customPageSize',items?.length,customPageSize);
      if(location==='studio'){
        setTimeout(function() {
          const run = async () => {
            await fetchTemplates(true);
            setTitle("No templates added")
          }
          run();
        }, 200);
      }
      }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [])
*/
  useEffect(() => {
    if(templates){ 
      if(templates.length>0){
          var newDesignTypes: any[] = [];

          if((templatesFormat.length>0)&&(!reload)){
            if(start>customPageSize || orderPublished==="UNPUBLISHED")newDesignTypes=templatesFormat;
          }
          else {
            setReload(false);
            if (refTop && refTop.current){
              refTop.current.scrollIntoView({ behavior: 'smooth', block: 'nearest'})
            }
            
            if(location==='studio')fetchCounter(JSON.stringify(userData));
          }

          for (var i = 0; i < templates.length; i++) {
            newDesignTypes.push(templates[i]);
          }
          
          setItemsfl([...newDesignTypes]);
      }
      if(templates.length<customPageSize){
        if((orderBy=="PUBLISHED")&&(orderPublished==='')){
            setOrderPublished("UNPUBLISHED");
            setStart(0);
            orderBy="UNPUBLISHED";
            const run = async () => {
              await fetchTemplates(false);
            }
            run();
        }
        else{
          setHasmore(false);
          setSpinner(false);
          if(start==customPageSize && templates.length===0){
            setItemsfl([] as any);
          }
        }
      }
      else{
        setHasmore(true);
        if(start>0)setSpinner(false);
      }
    }
  }, [templates])

  const debounce = useCallback(
    _.debounce((_searchVal: any) => {
      setFilter(_searchVal);
    }, 500),
    []
  );
  useEffect(() => debounce(filters), [filters]);

  useEffect(() => {
    if(Object.values(filter).length && activeFilter){
      setOrderPublished('');
      if (refTop && refTop.current){
        refTop.current.scrollIntoView({ behavior: 'smooth', block: 'nearest'})
      }
      setReload(true);
      const run = async () => {
        await fetchTemplates(true);
        setTitle("No templates added")
      }
      run();
    } else if (activeFilter) {
      setItemsfl([])
    }
  }, [filter])

  useEffect(() => {
    if(orderBy!==""){
      setOrderPublished('');
      if (refTop && refTop.current){
        refTop.current.scrollIntoView({ behavior: 'smooth', block: 'nearest'})
      }
      const run = async () => {
        await fetchTemplates(true);
      }
      run();
    }
  }, [orderBy])

  useEffect(() => {
    if((!initial)&&(!newTemplate)&&(reloadList)){
      setReload(true);
    }
    else setInitial(false);
  }, [newTemplate])

  useEffect(() => {
      if(reloadList){
        setReload(true);
        setStart(customPageSize);
      }
  }, [reloadList])

  useEffect(() => {    
    if(deteleItem.length>0){
      setStart(start-1);      
      let newList=templatesFormat.filter((item: any, idx:number) => !deteleItem.includes(idx));      
      if(newList.length==0){
        setSearchQuery('');
        const run = async () => {
          await fetchTemplates(true);
        }
        run();
        setReload(true);
        setStart(customPageSize);
      }
      else setItemsfl(newList);
    }
  }, [deteleItem])

  useEffect(() => {
    if (savedItems.length) {
      let newList = templatesFormat.map((item: any) => {
        const savedItem = savedItems.find(s => s.id === item.id);
        if (savedItem) return savedItem;
        else return item;
      });
      setItemsfl(newList);
    }
  }, [savedItems]);

  const handleClearSearch =  () => {
    setSearching(false);
    setShowList(false);
  }

  const handleSelectedIndexes = (index: number, action: IndexesActions) => {
    if (action === 'ADD') {
      setSelectedIndexes([...selectedIndexes, index]);
    } else if (action === 'REMOVE') {
      setSelectedIndexes([...selectedIndexes.filter(selectedIndex => selectedIndex !== index)]);
    }
  }
  

  let items= null
  let message='';
  let count= null;

  if(templates){
    items=templatesFormat.map((item:any, idx:number)=>{
        if(location==="templates" && !gridView) {
          return  <CSSTransition key={item.id} timeout={700} classNames="item">
                    <ItemTemplate
                      idx={idx}
                      item={item}
                      onActionsTemplate={onActionsTemplate}
                      selected={selectedIndexes.includes(idx)}
                      setOpen={setOpenOptions}
                      handleSelectedIndexes={handleSelectedIndexes}
                    />
                  </CSSTransition>
        } else 
          return  <CSSTransition key={item.id} timeout={700} classNames="item">
                    <PreviewComponent
                      index={idx}
                      key={item.id}
                      item={item}
                      clearSearch={() => handleClearSearch()}
                      showMetadata={true}
                      onActionsTemplate={onActionsTemplate}
                      selected={selectedIndexes.includes(idx)}
                      setOpen={setOpenOptions}
                      handleSelectedIndexes={handleSelectedIndexes}
                    />
                  </CSSTransition>
    });
    if(counter && counter.counter)count=counter.counter;

    if(items.length==0){
      if(location==="templates")message="There are no templates with those filters."
      else {
        count=0;
        message='';
      }
    }
    else if((items.length/customPageSize)>Math.floor(items.length/customPageSize) || !hasMore) message="There are no more templates."
    else message="";
  }

  let minHeight='';
  if(items && items.length<9)minHeight='100%';

  let top='186px';
  if(location==='studio' && !hasDesigns && filtering)top='390px';
  if(searching)top='186px';
  
  const handleClickOutside = (e: any)=> {
    if(selectedRefs && selectedRefs.current){
        const ref: (HTMLDivElement | null)[] = selectedRefs.current;
        let found = false;
        if (ref) {
          ref.forEach(refDesign => {
            if (refDesign?.contains(e.target)) found= true;
          });
          setTimeout(() => {
            if (!found && stateRef.current) {
              if (!e.shiftKey){
                setSelectedIndexes([]);
                setOpenOptions(false);
              }
            }
          }, 200)
        }
    }
  }

  const handleSelectionStart = useCallback(
    () => {
      setAllowClean(false);
    },
    []
  );

  const handleSelectionChange = useCallback((box) => {
  }, []);

  const handleSelectionEnd = useCallback(
    (box: SelectionBox) => {
      let indexesToSelect: number[] = [];
      const elementsContainer = document.getElementById("template-list");
      if (elementsContainer) {
        Array.from(elementsContainer.childNodes).forEach((item, index) => {
          const boundingBox = (item as Element).getBoundingClientRect();
          if (boxesIntersect(box, boundingBox)) {
            indexesToSelect.push(index);
          }
        });
      }
      setSelectedIndexes(indexesToSelect);
    },
    []
  );

  const handleSetCoordinates = (e: React.MouseEvent<HTMLDivElement>) => {
    if (openOptions === false)    
    {
      let scrollTop = scrollDiv.current?.scrollTop??0;
      setCoordinates({x: e.clientX - 180, y: e.clientY-200 + scrollTop});    
    }
  }

  useEffect(() => {
    if (stateRef) stateRef.current = allowClean;
  }, [allowClean]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  
  return (
    <S.Root
      id="scrollableDiv"
      flex={(location==="studio" || gridView)?true:false}
      top={top}
      onMouseMove={handleSetCoordinates}
      ref={scrollDiv}
    >
      <S.Container onMouseDown={() => setAllowClean(true)} >
        <MouseSelection
          onSelectionChange={handleSelectionChange}
          onSelectionEnd={handleSelectionEnd}
          onSelectionStart={handleSelectionStart}
        />
        <div ref={refTop}/>
        {spinner && <Spinner/>}
        {location==="studio" && !spinner  &&
        <S.Result>
          Results {value!=='' && `for “${value}”`}
          {count!=null && showCounter && 
          <S.Counter>{ new Intl.NumberFormat("en-IN").format(count)} results based on your criteria</S.Counter>}
          {sortByText!=''&&<S.Orderby>Sorted: {sortByText}</S.Orderby>}
        </S.Result>}

        {sortByText!='' && location==="templates" &&<S.Orderby float={false}>Sorted: {sortByText}</S.Orderby>}

        
        {!show && !spinner &&
        <>
            <InfiniteScroll
              dataLength={items ? items.length : 0}
              next={fetchTemplates}
              hasMore={hasMore}
              loader={<Loading 
                id={"loading-designs"}
                pointsColor='#f66000' 
                containerStyle={{justifyContent: 'center'}}
              />}
              scrollableTarget="scrollableDiv"
              endMessage={
                <S.Text style={spinner?{display:"none"}:{}}> {message} </S.Text>
              }
              style={{
                padding: '8px 10px 0px 10px',
                minHeight: minHeight,
                overflowX: 'hidden',
                marginTop: sortByText!='' ? '30px' : "5px"
              }}
            >
              <S.TypeContainer id={gridView?'gridList':'itemsList'}>
                <TransitionGroup className="group-list" id="template-list">
                  {items}
                </TransitionGroup>
              </S.TypeContainer>
            </InfiniteScroll>
            <RightClickMenu
        open={openOptions}
        setOpen={setOpenOptions}
        coordinates={coordinates}
        section={"Templates"}
        selectedIndexes={selectedIndexes}
        items={templatesFormat}
        onActionsTemplate={onActionsTemplate}
        handleWarningScreen={handleWarningScreen}
        deleteTemplates={deleteTemplates}
      />
      </>
            
        }
        
        {show && location==='templates' &&
        <S.ListEmty>
          <S.Tittle>{title}</S.Tittle>
          <S.SubTittle>
          Upload templates and manage them here. You’ll be able to see things like size, status, and the name of the file.  
          </S.SubTittle>
          <ListEmpty/> 
          <Button
              icon="add" 
              label="NEW TEMPLATE"
              style={{hoverBackgroundColor: "#344a70", backgroundColor: "#19325d", border: "1px solid white", width: 150, height: 40, boxSizing: 'border-box',display: "block", marginLeft: "auto", marginRight: "auto", marginTop:"5%"}}
              labelStyle={{color: "white"}}
              onClick={handleOpenNewTemplate}
          />        
        </S.ListEmty>
        }
      
      </S.Container>
     
    </S.Root >
  );
}

export default List;